/**
 * Debounce/coalesce rapid refresh callbacks (realtime bursts).
 */
export function createDebouncedRefresh(fn, waitMs = 400) {
    let timer = null;
    let pendingArgs = null;

    const schedule = (...args) => {
        pendingArgs = args;
        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            timer = null;
            const a = pendingArgs;
            pendingArgs = null;
            fn(...(a || []));
        }, waitMs);
    };

    schedule.cancel = () => {
        if (timer) clearTimeout(timer);
        timer = null;
        pendingArgs = null;
    };

    schedule.flush = () => {
        if (!timer) return;
        clearTimeout(timer);
        timer = null;
        const a = pendingArgs;
        pendingArgs = null;
        fn(...(a || []));
    };

    return schedule;
}
